<template>
  <div class="result-list-container cs-scroll-style" v-visible-track="'Iframe.ancientDnaClosestPopulationsPageView'">
    <SpinnerContainer v-if="!uiResults && this.$store.state.appConfig.isLoading"/>
    <template v-else>
      <div class="fit-container-genetic-similarity">
        <span class="cursor-pointer" @click="geneticFitInfoModal.showModal = true" 
          v-click-track="'Iframe.ancientDnaClosestPopulationsTabWhatIsGeneticFitClicked'">
          {{$tI('Genetic Fit')}} 
          <span class="open-info-modal-btn">
            <InfoIcon />
          </span>
        </span>
      </div>
      <div class="pop-view">
        <div v-for="itemAncestry in uiResults"
            :key="itemAncestry.title" 
            @click="onOpenDetailPage(itemAncestry)" class="pop-view-item"
            v-click-track="'Iframe.ancientDnaClosestPopulationsClickOnPopulationLeftPanel'">
          <div class="d-flex">
            <b-media-aside class="mr-75">
              <b-avatar
                rounded
                size="55"
                :src="itemAncestry.logoUrl"
              />
            </b-media-aside>
            <b-media-body class="my-auto">
              <h6 class="mb-0">
                {{ itemAncestry.tTitle }}
              </h6>
            </b-media-body>
          </div>
          <div class="d-flex align-items-center lab-p-8">
            <span class="mr-75 percent-txt" :style="{ color: itemAncestry.gradHSL }"><b>{{ itemAncestry.distance }}</b></span>
          </div>
        </div>
      </div>

      <GeneticFitInfoModal v-if="geneticFitInfoModal.showModal" :modalObject="geneticFitInfoModal"/>
    </template>
  </div>
</template>

<script>
import InfoIcon from '@/components/icons/InfoIcon.vue';
import GeneticFitInfoModal from '../../genetic-similarities/Modals/GeneticFitInfoModal.vue'

export default {
  components: {
    InfoIcon,
    GeneticFitInfoModal,
  },
  directives: {
  },
  data() {
    return {
      geneticFitInfoModal: {
        showModal: false,
      },
    }
  },
  methods: {
    onOpenDetailPage(item) {
      if (!item.id) {
        return;
      }
      this.$store.dispatch('ancientProxResult/fetchAncientProxDetail',{ report: 'SingleOrigin,' + item.title, id: item.id });
      this.$store.state.ancientProxResult.isOpenedAncientProxDetail = true;
    },
  },
  computed: {
    uiResults() {
      const results = this.$store.getters['ancientProxResult/getUiResults'];
      return results;
    },
  },
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
.result-list-container {
  padding: 28px;
  flex: 1;
  overflow-y: auto;
  
  .fit-container-genetic-similarity {
    color: var(--black-40);
    text-align: end;
    font-size: 0.9rem;
    .open-info-modal-btn {
      margin-left: 5px;
    }
  }
}
</style>
